import { notifications } from '@mantine/notifications';
import { useSetAtom } from 'jotai';
import { api } from '~/trpc-extra/api';
import { isAcceptingAutohealChangesAtom } from '~/atoms/atoms';

export function useAcceptAutohealChanges({
  testContentId,
  onSuccess,
}: {
  testContentId: string;
  onSuccess?: () => Promise<void> | void;
}) {
  const trpcUtils = api.useUtils();
  const setIsAcceptingAutohealChanges = useSetAtom(isAcceptingAutohealChangesAtom(testContentId));

  const { mutateAsync, isPending } = api.testDraft.publishTestDraft.useMutation({
    onMutate: () => {
      // Set loading state for this specific test content
      setIsAcceptingAutohealChanges(true);
    },
    onSuccess: async () => {
      // Invalidate test queries to ensure diffview state updates correctly
      await Promise.allSettled([trpcUtils.test.getTest.invalidate(), trpcUtils.test.getMeta.invalidate()]);

      await onSuccess?.();
    },
    onError: (e) => {
      console.error(e);
      notifications.show({ message: 'Failed to accept changes', color: 'red' });
    },
    onSettled: () => {
      // Reset loading state for this specific test content
      setIsAcceptingAutohealChanges(false);
    },
  });

  const acceptChanges = async () => {
    await mutateAsync({ testContentId });
  };

  return {
    acceptChanges,
    isPending,
  };
}
